import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "src/core/lib/utils";

const labelVariants = cva(
  "text-base font-light peer-disabled:cursor-not-allowed peer-disabled:opacity-70 [&::placeholder]:text-muted-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
  {
    variants: {
      variant: {
        default: "form-input",
        inline:
          "h-input outline-none rounded-lg border border-input bg-white px-10 py-5 font-light",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

type InputProps = React.ComponentProps<"input"> & VariantProps<typeof labelVariants>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          labelVariants({ variant }),
          props.disabled && "opacity-50 cursor-not-allowed",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
